export default __webpack_public_path__ + "static/media/c_mobile_dr_03.0a8c2b44.png";